module.exports = __webpack_public_path__ + "img/37.02c48241.jpg";